import React, { useState } from 'react';
import { StyledContainer } from '../cliam/claim-detail/styles';
import { ButtonTheme, TextLarge } from '../../components';
import { ContainerButton } from '../../styles/global-style';
import { ResponsivePageLayout } from '../../components/page-layout/ResponsivePageLayout';
import { useModal } from '../../components/modal/hooks/useModal';
import { columns } from './columns';
import { useLineMessageTemplateList } from './hooks/useLineMessageTemplateList';
import { useDeleteLineMessageTemplate } from './hooks/useDeleteLineMessageTemplate';
import { TemplateFormModal } from './modal/TemplateFormModal';

export const LineMessageTemplate = () => {
  const [editing, setEditing] = useState(null);
  const { open: openModal, onToggle: onToggleModal } = useModal();

  const { data: dataSource = [], isPending, refetch } = useLineMessageTemplateList();

  const { mutate: deleteTemplate } = useDeleteLineMessageTemplate({ onSuccessCallBack: refetch });

  const onAdd = () => {
    setEditing(null);
    onToggleModal({ defaultValues: null });
  };

  const onEdit = (record) => {
    setEditing(record);
    onToggleModal({ defaultValues: record });
  };

  return (
    <StyledContainer>
      <TextLarge text="Template ข้อความ LINE" />
      <ContainerButton right>
        <ButtonTheme useFor="WARRANTY" title="เพิ่ม template" onClick={onAdd} />
      </ContainerButton>
      <ResponsivePageLayout
        tableLayout={{
          columns: columns({ onEdit, onDelete: deleteTemplate }),
          dataSource,
          loading: isPending,
          hasPagination: true,
          rowKey: 'templateId',
        }}
      />
      {openModal && (
        <TemplateFormModal
          open={openModal}
          onToggle={onToggleModal}
          onFetch={refetch}
          initialValues={editing}
        />
      )}
    </StyledContainer>
  );
};
